import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";

// Pages
import Home from "./pages/Home";
import HomeNew from "./pages/HomeNew";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import DashboardNew from "./pages/DashboardNew";
import CoupleInvite from "./pages/CoupleInvite";
import ChatPage from "./pages/ChatPage";

// Components
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";

// Contexts
import { AuthProvider } from "./contexts/AuthContext";
import { CoupleProvider } from "./contexts/CoupleContext";

const App = () => {
  return (
    <AuthProvider>
      <CoupleProvider>
        <Router>
          <div className="min-h-screen bg-background">
            <Routes>
              <Route path="/" element={<HomeNew />} />
              <Route path="/home-old" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/couple/join/:token" element={<CoupleInvite />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <DashboardNew />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard-old"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/chat/:sessionId"
                element={
                  <ProtectedRoute>
                    <ChatPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/suggestions"
                element={
                  <ProtectedRoute>
                    <DashboardNew />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/analytics"
                element={
                  <ProtectedRoute>
                    <DashboardNew />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <AdminRoute>
                    <DashboardNew />
                  </AdminRoute>
                }
              />
            </Routes>
            <Analytics 
              beforeSend={(event) => {
                // Filter out admin and development events in production
                if (process.env.NODE_ENV === 'production') {
                  if (event.url?.includes('/admin') || event.url?.includes('/debug')) {
                    return null;
                  }
                }
                return event;
              }}
              debug={process.env.NODE_ENV === 'development'}
            />
            <SpeedInsights 
              debug={process.env.NODE_ENV === 'development'}
            />
          </div>
        </Router>
      </CoupleProvider>
    </AuthProvider>
  );
};

export default App;